import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-common-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements AfterViewInit  {
 @Input() items: [] = [];

  visibleItems: [] = [];
  expanded: boolean = false;
  isSmallScreen: boolean = false;
  hiddenCount: number = 0;
  showToggleButton: boolean = false;

  @ViewChild('container') containerRef!: ElementRef;

  constructor() {}

  ngAfterViewInit(): void {
    this.initializeAfterRender();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.initializeAfterRender();
    }
  }
 @HostListener('window:resize')
  onResize() {
     this.checkScreenSize();
    this.initializeAfterRender();
  }
 private initializeAfterRender(): void {
    setTimeout(() => {
      this.checkScreenSize();
      this.calculateVisibleItems();
    });
  }
  private checkScreenSize(): void {
    this.isSmallScreen = window.innerWidth < 1200;
  }

// private calculateVisibleItems(): void {
//     if (this.expanded) {
//       this.visibleItems = [...this.items];
//       this.hiddenCount = 0;
//       return;
//     }

//     const container = this.containerRef.nativeElement as HTMLElement;
//     const itemElements = Array.from(container.querySelectorAll('.item')) as HTMLElement[];

//     this.visibleItems = [...this.items];
//     this.hiddenCount = 0;

//     setTimeout(() => {
//       let totalWidth = 0;
//       const containerWidth = container.clientWidth;

//       this.visibleItems = [];
//       for (let i = 0; i < this.items.length; i++) {
//         const child = itemElements[i];
//         if (!child) break;

//         totalWidth += child.offsetWidth;

//         const countIndicatorWidth = 40;
//         const toggleButtonWidth = 80;

//         if (totalWidth + countIndicatorWidth + toggleButtonWidth <= containerWidth) {
//           this.visibleItems.push(this.items[i]);
//         } else {
//           break;
//         }
//       }

//       this.hiddenCount = this.items.length - this.visibleItems.length;
//     });
//   }

private calculateVisibleItems(): void {
    if (this.expanded) {
      this.visibleItems = [...this.items];
      this.hiddenCount = 0;
      this.showToggleButton = true;
      return;
    }

    const container = this.containerRef.nativeElement as HTMLElement;
    const itemElements = Array.from(container.querySelectorAll('.item')) as HTMLElement[];

    if (itemElements.length === 0) {
      setTimeout(() => this.calculateVisibleItems(), 10); // Retry after next render
      return;
    }

    this.visibleItems = [...this.items];
    this.hiddenCount = 0;
    this.showToggleButton = false;

    setTimeout(() => {
      let totalWidth = 0;
      const containerWidth = container.clientWidth;

      this.visibleItems = [];
      for (let i = 0; i < this.items.length; i++) {
        const child = itemElements[i];
        if (!child) break;

        totalWidth += child.offsetWidth;

        const countIndicatorWidth = 40;
        const toggleButtonWidth = 80;

        if (totalWidth + countIndicatorWidth + toggleButtonWidth <= containerWidth) {
          this.visibleItems.push(this.items[i]);
        } else {
          break;
        }
      }

      this.hiddenCount = this.items.length - this.visibleItems.length;
      this.showToggleButton = this.hiddenCount > 0;
    });
  }

  toggleExpand(): void {
    this.expanded = !this.expanded;
    this.initializeAfterRender();
  }
}
